export default {
    routerName: '部門追加',
    dept: {
        name: '部門名',
        parentDeptName: '親部門',
        leader: '責任者',
        status: '状態',
        open: '有効',
        close: '無効',
        mobile: '携帯電話',
        email: 'メール',
        sortOrder: 'ソート',
    },
};
